import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=558c7b10&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=558c7b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558c7b10",
  null
  
)

export default component.exports